// React-Screen COtherFunctions - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
// ENTSCHALT am 23.8.2026 (Nutzer-Vorgabe: keine Huellen mehr, verbindlich
// sind Pixelgleichheit und 100% Funktionalitaet). React rendert die
// Knoepfe jetzt selbst ueber den gemeinsamen Baustein SecondaryPanel;
// der Legacy-Widget-Baum aus LYT_secondaryPanel.xml kommt nicht mehr vor.
// Die HANDLER sind weiter ueber spec.legacyMethods WOERTLICH uebernommen
// (Bridge-Vertrag 8) - `this`/`me` ist die Bridge.
import { defineReactScreen } from '../bridge.js';
import { SecondaryPanel } from '../secondaryPanel.jsx';
import { schlussbelegErstellen, schlussbelegSichern, schlussbelegMelden } from '../../receipt/schlussbeleg.js';

const legacy = {};


legacy.setMain = function(main) {
    this.Main = main;
}

legacy.setCallback = function() {
    POS.events.setOnClickEventCallback(this, this.disappear, true);
}

legacy.disappear = function(me) {
    me.Main.lastSubmenuId = "OF";
    window.setTimeout(me.Main.restoreLastSubmenuId, 0, me.Main);
    /*me.properties.styles.visibility = "hidden";
    me.reStyle();*/
    document.getElementById(me.id).style.visibility="hidden";
}

legacy.restartX = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);


    var text = POS.lang.getText("MESSAGES", "CONF_RESET_X");
    POS.message.show(text, "question", "YESNO", me, me.doRestartX);
}

legacy.doRestartX = function(me, result) {

    if (result != "YES")
        return;

    /*privMan.enablePrivilege (privList);*/

    /*  var VisoTech = Components.classes["@visotech.at/VisoTech;1"].
    createInstance(Components.interfaces.nsIVisoTech);
     */
    try {

//        execute("/usr/bin/sudo /bin/kill `pidof X`", 5000);
location.href = location.href;

    } catch (e) {
        log.add(1, "Error", "X-Restart failed", e);
    }
}

legacy.bonSave = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var cmpAbout = me.Main.addChild(CBonSaveMode);
    cmpAbout.draw();
	document.getElementById(cmpAbout.id).style.visibility = "visible";
}


legacy.insertZeroBon = function(callback) {
    //    var me = POS.getComponentById(parameters[0]);
	if (callback.name && callback.name=='CPushButton') callback=null;
    // Nacharbeit B4: an einer abgemeldeten Kasse kein Nullbeleg mehr.
    if (POS.Smartcard && POS.Smartcard.ausserBetrieb) { POS.Smartcard.ausserBetriebMelden(); return; }
    $.when(POS.SQLiteCon.lastInsertBonRegId()).done(function(ID) {
        var Receipt = new CReceipt(parseInt(ID) + 1);
        $.when(Receipt.defreturn).done(function(c) {
            var d = new Date();
            var yyyy = d.getFullYear().toString();
            var mm = (d.getMonth() + 1).toString(); // getMonth() is zero-based
            mm = (mm[1] ? mm : "0" + mm[0]);
            var dd = d.getDate().toString();
            var hh = d.getHours().toString();
            var min = d.getMinutes().toString();
            var ss = d.getSeconds().toString();
            var date = yyyy + "-" + mm + "-" + (dd[1] ? dd : "0" + dd[0]) + "T" + (hh[1] ? hh : "0" + hh[0]) + ":" + (min[1] ? min : "0" + min[0]) + ":" + (ss[1] ? ss : "0" + ss[0]);
            $.when(Receipt.insertZeroSentence("MZR", date, true, callback)).done(function(ID) {
                /*var text = "BON gedruckt!";
                POS.message.show(text, "warning", "OK");*/
                if (callback){
					//callback();
                }
            });

        });

    });
}


legacy.aboutWindow = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var cmpAbout = me.Main.addChild(CAboutMode);
    cmpAbout.draw();
    document.getElementById(cmpAbout.id).style.visibility="visible";
}

legacy.ssave = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    var text = POS.lang.getText("MESSAGES", "PLEASE_WAIT");
    POS.hourGlass.show(text, POS.sessions.getSessionComponent(), me.doSsave);
}

legacy.doSsave = function(Main) {
    POS.sessions.hideCurrentSession();

    POS.Screensaver = POS.sessions.openSessions[0].addChild(CScreenSaver);
    POS.Screensaver.draw();
    POS.events.applyTS = false;

    POS.hourGlass.hide();
}

legacy.shutdown = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);


    var text = POS.lang.getText("MESSAGES", "CONF_SHUTDOWN");
    POS.message.show(text, "question", "YESNO", me, me.doShutdown);
}


// Nacharbeit B (Nutzer 1.10.2026): "Beim Finanzamt abmelden" ist die
// ENDGUELTIGE Ausserbetriebnahme der Kasse (RKSV § 17 Abs. 1 und 8): nach der
// Bestaetigung ein signierter Schlussbeleg SCH (Nullbeleg, gedruckt) als
// letzter Beleg, dann belegpruefung + Meldung ausfall_kasse/ausserbetriebnahme
// (Grund 6) ueber Kassenserver -> Zentrale. Danach verweigert die Kasse jeden
// Beleg. Rueckgaengig nur von Hand (tools/RKSV-ONLINE-SIGNATUR.md 12.11).
// Frueher: Nullbeleg MZR + belegpruefung (mit einer Funktion statt Beleg) +
// Ausfallmeldung (99) und var/etc/isOffline - das gibt es nicht mehr (eine
// "Wiederanmeldung" nach endgueltiger Ausserbetriebnahme waere falsch).
legacy.goOffline = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);
    // Erst der echte Zustand (Kassenserver-Sperre; fehlt der Schlussbeleg in
    // BONREG, wird er dabei nachgetragen), dann die Zentrale (Fix-Runde 1).
    $.when(schlussbelegSichern()).then(function (s) {
        if (s.status !== "offen") return abmeldenErgebnis(s, false);
        $.ajax({ url: "rksv/zentrale", cache: false, timeout: 15000,
            success: function (a) {
                if (!a || !a.ok || !a.zentrale)
                    return POS.message.show("Abmelden nicht möglich: diese Kasse ist nicht mit der Zentrale verbunden. Bitte Support anrufen!", "warning", "OK");
                if (a.eintrag === "nein")
                    return POS.message.show("Abmelden nicht möglich: die Zentrale hat für diese Kasse keinen RKSV-Eintrag. Bitte Support anrufen!", "warning", "OK");
                if (a.eintrag !== "ja")
                    return POS.message.show("Abmelden derzeit nicht möglich: die Zentrale ist nicht erreichbar. Bitte später noch einmal versuchen!", "warning", "OK");
                var text = "Kasse " + POS.POSId + " beim Finanzamt ENDGÜLTIG abmelden? Danach können an dieser Kasse keine Belege mehr ausgestellt werden.";
                POS.message.show(text, "question", "YESNO", me, me.doGoOffline);
            },
            error: function () {
                POS.message.show("Abmelden nicht möglich: diese Kasse ist nicht mit der Zentrale verbunden. Bitte Support anrufen!", "warning", "OK");
            }
        });
    });
}

legacy.doGoOffline = function(me, result) {
    if (result != "YES")
        return;
    $.when(schlussbelegErstellen()).then(function (erg) {
        if (erg.ok) return abmeldenMelden(erg.receiptID, erg.qr);
        // Nicht (sicher) fertig: NIE raten - den echten Zustand pruefen
        // (Sperre? Schlussbeleg in BONREG? sonst nachtragen). Laeuft in der
        // Belegwarteschlange, also erst nach dem Ende des Schlussbeleg-Wegs.
        $.when(schlussbelegSichern()).then(function (s) { abmeldenErgebnis(s, true, erg); });
    });
}

// Belegpruefung + Meldung ueber die Zentrale, dann die Abschlussmeldung.
function abmeldenMelden(receiptID, qr) {
    $.when(schlussbelegMelden(qr)).then(function (m) {
        POS.message.show(m.meldung ?
            "Die Kasse ist beim Finanzamt abgemeldet (Schlussbeleg Nr. " + receiptID + " gedruckt). An dieser Kasse können keine Belege mehr ausgestellt werden." :
            "Schlussbeleg Nr. " + receiptID + " gedruckt, die Kasse ist gesperrt. Die Meldung an das Finanzamt ist noch nicht gelungen - die Zentrale wiederholt sie automatisch.",
            m.meldung ? null : "warning", "OK");
    });
}

// s: Ergebnis von schlussbelegSichern. eigen: dieser Abmelde-Vorgang lief
// gerade (erg = sein Ergebnis), sonst nur der Menueaufruf.
function abmeldenErgebnis(s, eigen, erg) {
    if (s.status === "nachgetragen" || (s.status === "vorhanden" && eigen && erg.phase === "sch"))
        return abmeldenMelden(s.receiptID, s.qr);
    if (s.status === "vorhanden")
        return POS.message.show("Diese Kasse ist bereits beim Finanzamt abgemeldet (Schlussbeleg Nr. " + s.receiptID +
            "). Die Meldung an das Finanzamt erledigt die Zentrale.", "warning", "OK");
    if (s.status === "fehler")
        return POS.message.show("Die Kasse ist gesperrt, der Schlussbeleg konnte aber nicht ins Belegprotokoll übernommen werden. Bitte Support anrufen!", "warning", "OK");
    // Fix-Runde 2: Zustand des Kassenservers nicht lesbar (bzw. eigener
    // Schlussbeleg noch in Arbeit) - nie "NICHT abgemeldet" raten.
    if (s.status === "unklar")
        return POS.message.show("Zustand unklar: der Zustand der Kasse kann gerade nicht gelesen werden. Bitte Support anrufen!", "warning", "OK");
    if (!eigen) return;
    if (erg.zeitlimit && erg.phase === "sch")
        return POS.message.show("Zustand unklar: der Schlussbeleg wurde begonnen, die Kasse ist aber nicht gesperrt. Bitte Support anrufen!", "warning", "OK");
    if (erg.zeitlimit)
        return POS.message.show("Der Schlussbeleg konnte nicht rechtzeitig erstellt werden. Die Kasse wurde NICHT abgemeldet und kann weiter verwendet werden.", "warning", "OK");
    // Fix-Runde 2 (Minor 3): der echte Grund - Phase 'vor' = faellige Vorbelege
    // bzw. Belegdaten, Phase 'sch' = Signatur/Speichern des Schlussbelegs.
    if (erg.phase === "vor")
        return POS.message.show("Der Schlussbeleg konnte nicht erstellt werden (" + (erg.grund === "Vorbelege" ?
            "fällige Monats-/Jahres-/Sammelbelege konnten nicht erstellt werden" : "Belegdaten nicht lesbar") +
            "). Die Kasse wurde NICHT abgemeldet und kann weiter verwendet werden.", "warning", "OK");
    POS.message.show("Der Schlussbeleg konnte nicht signiert werden (Sicherheitseinrichtung nicht erreichbar). Die Kasse wurde NICHT abgemeldet und kann weiter verwendet werden.", "warning", "OK");
}



legacy.doShutdown = function(me, result) {

    if (result != "YES")
        return;

    /*privMan.enablePrivilege (privList);

    var VisoTech = Components.classes["@visotech.at/VisoTech;1"].
    createInstance(Components.interfaces.nsIVisoTech);*/

    try {
        execute("/usr/bin/sudo /bin/kill `pidof X`", 5000);
        // VisoTech.exeootcuteAndWait("sudo /sbin/halt");
    } catch (e) {
        log.add(1, "Error", "Shutdown failed", e);
    }
}

function executeShellCommand(str, log) {

    var util = require('util'),
        exec = require('child_process').exec,
        child;

    child = exec(str, // command line argument directly in string
        function(error, stdout, stderr) { // one easy function to capture data/errors
            console.log('stdout: ' + stdout);
            console.log('stderr: ' + stderr);
            if (error !== null) {
                console.log('exec error: ' + error);
                log.add(1, "Error", log, error);
                return false;
            } else {
                return true;
            }
        });
    return false;
}


function COtherFunctionsScreen({ bridge }) {
  const t = bridge.t;

  // Reihenfolge und Beschriftungen exakt wie im Legacy-makeFunctionButtons
  // (dort wurde btns[1] vor btns[0] gesetzt - fuer das Ergebnis egal).
  const knoepfe = [
    { text: t('BUTTONS', 'SCREENSAVER'), handler: bridge.ssave },
    { text: 'Bons speichern', handler: bridge.bonSave },
    { text: t('BUTTONS', 'SHUTDOWN'), handler: bridge.shutdown },
    { text: t('BUTTONS', 'ABOUT'), handler: bridge.aboutWindow },
    { text: t('BUTTONS', 'RESTART_X'), handler: bridge.restartX },
    { text: 'Null-BON drucken', handler: bridge.insertZeroBon },
    { text: 'Beim Finanzamt abmelden', handler: bridge.goOffline },
  ];

  return <SecondaryPanel bridge={bridge} spalten={7} knoepfe={knoepfe} />;
}

// Legacy-Konstruktor zum Uebertragen (addclass/htmlType/rootStyles/Felder):
// function COtherFunctions(id) {
//     this.construct(id, "secondaryPanel COtherFunctions");
// 
//     this.htmlType = "span";
// 
//     this.properties = {
//         styles: {}
//     }
// 
//     this.Main = null;
// }
export const COtherFunctions = defineReactScreen({
  className: 'COtherFunctions',
  addclass: 'secondaryPanel COtherFunctions',
  htmlType: 'span',
  Screen: COtherFunctionsScreen,
  // Kein prepare/mountLegacy mehr: das Legacy-prepare baute den
  // Widget-Baum aus LYT_secondaryPanel.xml, den rendert jetzt React
  // selbst (SecondaryPanel). Uebrig bleiben die Methoden - die sind
  // WOERTLICH die alten.
  legacyMethods: legacy,
});

// Der Legacy-Huelle lag neben der Klasse noch dieser Helfer bei; er
// wandert mit, damit legacy-bridge.js ihn weiter beziehen kann.
export { executeShellCommand };
